import React from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';

const ScaledImage = styled.img`
  max-height: ${props => props.height}px;
  padding: 4px 8px;
  display: block;
  margin: 0 auto; /* Centers the image */
`;

const BrandedLogo = ({ url, height, className }) => (
  <ScaledImage height={height} src={url} alt="logo" className={className} />
);

BrandedLogo.propTypes = {
  height: PropTypes.number.isRequired,
  url: PropTypes.string.isRequired,
  className: PropTypes.string,
};

BrandedLogo.defaultProps = {
  className: undefined,
};

export default BrandedLogo;
